import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'

import { icons } from './assets/icons'

import { Provider } from 'react-redux'
import store from './store'

React.icons = icons

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'),
)

serviceWorker.register({
  onUpdate: (registration) => {
    const waitingWorker = registration.waiting
    if (waitingWorker) {
      if (window.confirm('نسخه جدید آماده‌ست. الان بارگذاری بشه؟')) {
        waitingWorker.postMessage({ type: 'SKIP_WAITING' })
      }
    }
  },
})

let refreshing = false
navigator.serviceWorker?.addEventListener('controllerchange', () => {
  if (refreshing) return
  refreshing = true
  window.location.reload()
})
